"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var SearcherEmptyTitle = function SearcherEmptyTitle(_ref) {
  var label = _ref.label,
    dateText = _ref.dateText,
    isHotelOnly = _ref.isHotelOnly;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledHeading, null, label || /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, t('hotel.searcher.emptyTitle.label', {
    context: isHotelOnly ? 'hotel' : 'package'
  }), /*#__PURE__*/_react["default"].createElement(StyledPre, null, dateText ? "".concat(t('hotel.searcher.emptyTitle.date')).concat(dateText) : "".concat(t('hotel.searcher.emptyTitle.dateText')))));
};
var StyledHeading = _styledComponents["default"].div.withConfig({
  displayName: "SearcherEmptyTitle__StyledHeading",
  componentId: "sc-1w3dza-0"
})(["", ";margin-bottom:10px;"], function (props) {
  return props.theme.typography.headline3;
});
var StyledPre = _styledComponents["default"].span.withConfig({
  displayName: "SearcherEmptyTitle__StyledPre",
  componentId: "sc-1w3dza-1"
})(["white-space:pre;"]);
var _default = exports["default"] = SearcherEmptyTitle;